import {LABELS} from '../constants/labels'
import {AddedLabelsRendering, type LabeledEventFragment} from './LabeledEvent'
import {type UnlabeledEventFragment, UnlabeledRendering} from './UnlabeledEvent'

type LabeledEventProps = {
  rollupGroup: Record<string, Array<LabeledEventFragment | UnlabeledEventFragment>>
  timelineEventBaseUrl: string
}
export function RolledupLabeledEvent({rollupGroup, timelineEventBaseUrl}: LabeledEventProps): React.ReactElement {
  const addedEvents = (rollupGroup['LabeledEvent'] as LabeledEventFragment[]) || []
  const removedEvents = (rollupGroup['UnlabeledEvent'] as UnlabeledEventFragment[]) || []

  return (
    <>
      <AddedLabelsRendering queryRefs={addedEvents} timelineEventBaseUrl={timelineEventBaseUrl} />
      {addedEvents.length > 0 && removedEvents.length > 0 && `${LABELS.timeline.and} `}
      <UnlabeledRendering queryRefs={removedEvents} timelineEventBaseUrl={timelineEventBaseUrl} />
    </>
  )
}
